import { setActiveLanguage } from '@app/+state/dashboard.actions';
import { getBrowserLanguage } from '@cirklo/angular/i18n';
import { Language } from '@cirklo/client';
import { createFeature, createReducer, on } from '@ngrx/store';

export const LANGUAGE_STORAGE_KEY = 'lang';

export function getLanguageFromStorage(): Language | null {
    const language = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return language ? (language.toUpperCase() as Language) : null;
}

export function storeLanguage(language: Language): void {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
}

interface State {
    language: Language;
}

const initialState: State = {
    language: getLanguageFromStorage() || getBrowserLanguage() || Language.EN,
};

const reducer = createReducer(
    initialState,
    on(setActiveLanguage, (s, action): State => ({ ...s, language: action.language })),
);

export const dashboardFeature = createFeature({ name: 'dashboard', reducer });
